import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubnavComponent } from './subnav.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';



@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        SubnavComponent
  ],  
    exports: [SubnavComponent]
})
export class SubnavModule { }
